
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
	name: 'TeamCard',
	props: {
		team: { type: Object, default: null },
		company: { type: Object, default: null },
		selected: { type: Boolean, default: false },
		selectionMode: { type: Boolean, default: false },
	},
	computed: {
		...mapGetters([
			'displayLabels',
		]),
	},
	methods: {
		handleClick () {
			if (this.selectionMode) {
				this.$emit('on-select');
			}
		},
	},
});
